import { useCallback, useMemo, type MouseEvent } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { Breadcrumbs } from '@loadsmart/loadsmart-ui'

import { parseQueryString, stringifyQueryString } from 'core/infra/queryString'

import user from 'legacy/utils/user'

import { getMagicLinkToken } from 'auth/use-cases/getMagicLinkToken'

import { resolveShipmentsListPath } from './resolveShipmentsListPath'

export type ShipmenDetailsBreadcrumbProps = {
  shipmentTitle: string
}

export function ShipmentDetailsBreadcrumb({ shipmentTitle }: ShipmenDetailsBreadcrumbProps) {
  const history = useHistory()
  const { pathname, search } = useLocation()
  const shipmentsPath = resolveShipmentsListPath(pathname)

  const canReturnToShipmentsList = user.isLoggedIn() || Boolean(getMagicLinkToken())

  const handleBackToShipperLoads = useCallback(() => {
    history.push(shipmentsPath)
  }, [history, shipmentsPath])

  const breadcrumbEntries = useMemo(
    () => [
      {
        label: 'Shipments',
        url: `#${shipmentsPath}`,
      },
      { label: `Shipment #${shipmentTitle}` },
    ],
    [shipmentTitle, shipmentsPath]
  )

  // Intercept any breadcrumb click (back button or Shipments link) for visitors
  // who can't reach a list, and open the sign-up dialog instead of navigating.
  function handleUnsignedClick(e: MouseEvent<HTMLDivElement>) {
    if (!canReturnToShipmentsList) {
      e.stopPropagation()
      e.preventDefault()

      history.replace({
        search: stringifyQueryString({ ...parseQueryString(search), signup: 'true' }),
      })
    }
  }

  return (
    <div onClickCapture={handleUnsignedClick}>
      <Breadcrumbs onBack={handleBackToShipperLoads} entries={breadcrumbEntries} />
    </div>
  )
}
